// extracted by mini-css-extract-plugin
var _1 = "GnTxdLjaEAveUAPAK3Vg";
var _2 = "oey3bq5PwwyB0YEjvNC0";
var _3 = "wiVGqipIp7M28JdA_07g";
var _4 = "tGyt_x2fGxoqlBqCw7g1";
var _5 = "KORnrRXGiyFD9X343WtL";
export { _1 as "description", _2 as "divider", _3 as "showLess", _4 as "showMore", _5 as "title" }
